import { fmtCurrency } from "../../../../utils/functions";
import styles from "./summary.module.css";

export default function OrderRecap({ product, productType, currency }) {
  const isPack = productType === "pack";
  const { name, price, credits, creditsPerMonth } = product;

  return (
    <div className={styles.recapCard}>
      <div className={styles.recapLabel}>Your order</div>
      <div className={styles.recapHead}>
        <span className={styles.recapIcon}>{isPack ? "🪙" : "📆"}</span>
        <div>
          <div className={styles.recapName}>
            {isPack ? `${name} Pack` : `${name} Annual`}
          </div>
          <div className={styles.recapMeta}>
            {isPack
              ? `${credits} credits · never expire`
              : `${creditsPerMonth}C/mo · 12-month rollover`}
          </div>
        </div>
      </div>
      <div className={styles.recapFooter}>
        <div className={styles.recapRow}>
          <span className={styles.recapTotalLbl}>Total today</span>
          <span className={styles.recapTotalVal}>
            {fmtCurrency(price, currency)}
          </span>
        </div>
        <div className={styles.recapNote}>
          {isPack ? "One-time · no subscription" : "One-time · renews annually"}
        </div>
      </div>
    </div>
  );
}
